import { Link, useLocation } from "react-router-dom";
import { getUser } from "../auth"; 
import "./Breadcrumbs.css";

const Breadcrumbs = () => {
  const { pathname } = useLocation();
  const user = getUser(); // MUST BE INSIDE COMPONENT
  const isVocovoUser = user?.role !== "Customer";
  if (pathname === "/dashboard" || pathname === "/customer/dashboard") {
  return null;      // hide breadcrumbs on Dashboard
}


  let items = [];

  // Always start with Dashboard
items.push({
  label: "Dashboard",
  path: isVocovoUser ? "/dashboard" : "/customer/dashboard",
});


  // PRODUCT MANAGEMENT
  if (pathname.startsWith("/products")) {
    items.push({
      label: "Product Management",
      path: pathname === "/products" ? null : "/products", // link ONLY if not final page
      state: { restoreProductState: true },
    });

    if (pathname.includes("add-product")) {
      items.push({ label: "Add Product" });
    }

    if (pathname.includes("edit")) {
      items.push({ label: "Edit Product" });
    }

    if (pathname.includes("history")) {
      items.push({ label: "History" });
    }
  }

  // USER MANAGEMENT
  if (pathname.startsWith("/users")) {
    items.push({ label: "User Management" });
  }

  // CUSTOMER PRICE MGMT
  if (pathname.startsWith("/discounts")) {
    items.push({ label: "Customer Price Management" });

    
  }

  // MARGIN CALCULATOR
  if (pathname === "/margin-calculator") {
  items.push({ label: "Margin Calculator" });
}

  // CALCULATE MARGIN PAGE (add-screen)
if (pathname === "/calculate-margin") {
  items.push({ label: "Margin Calculator", path: "/margin-calculator" });
  items.push({ label: "Calculate Margin" });
}

if (pathname.startsWith("/margin-calculator/")) {
  items.push({ label: "Margin Calculator", path: "/margin-calculator" });
  items.push({ label: "Margin Details" });
}
//   }
// // ADD / CALCULATE MARGIN VIEW
// if (pathname === "/margin-calculator" && window.location.hash === "#add") {
//   items.push({
//     label: "Margin Calculator",
//     path: "/margin-calculator",  // make clickable
//   });

//   items.push({
//     label: "Calculate Margin",
//     path: null, // final, not clickable
//   });
// }

  // QUOTES
  if (pathname.startsWith("/quotes")) {
     items.push({
      label: "PO Template",
      path: pathname === "/quotes" ? null : "/quotes", // link ONLY if not final page
    });
    if (pathname.includes("/quotes/add-quote")) {
      items.push({ label: "Create Purchase Order" });
    }
    if (pathname.includes("edit")) {
      items.push({ label: "Edit Purchase Order" });
    }

    if (pathname.includes("view")) {
      items.push({ label: "PO Template Details" });
    }
  }

  // ORDERS
  if (pathname.startsWith("/orders")) {
    items.push({
      label: "Orders",
      path: pathname === "/orders" ? null : "/orders", // link ONLY if not final page
    });
    if (pathname.includes("/orders/add-order")) {
      items.push({ label: "Create Order" });
    }
    if (pathname.includes("edit")) {
      items.push({ label: "Edit Order" });
    }
     if (pathname.includes("view")) {
      items.push({ label: "Order Details" });
    }

  }

  // CUSTOMER pages
  // if (pathname.startsWith("/customer/dashboard")) {
  //   items.push({ label: "Dashboard" });
  // }

  if (pathname.startsWith("/customer/orders")) {
    items.push({ label: "My Orders" });
  }
  if (pathname.startsWith("/customer/quotes")) {
    items.push({ label: "Quotes" });
  }

  if (pathname.startsWith("/customer/price-listing")) {
    items.push({ label: "My Price List" });
  }

  return (
    <div className="breadcrumbs">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <span key={index} className="breadcrumb-item">
            {/* clickable only if path exists AND not last item */}
            {!isLast && item.path ? (
              <Link
                  to={item.path}
                  state={item.state}
                  className="breadcrumb-link"
                >
                  {item.label}
                </Link>

            ) : (
              <span className={isLast ? "breadcrumb-current" : "breadcrumb-link-disabled"}>
                {item.label}
              </span>
            )}

            {/* separator only if NOT last item */}
            {!isLast && <span className="breadcrumb-separator">❯</span>}
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
